import { useHasRole } from '../../hooks/useHasRole';

/**
 * 角色權限守衛組件 - 根據用戶角色決定是否顯示子元素
 * @param {number} requiredRole - 所需的最低角色等級（1=外包, 2=員工, 3=財務, 4=經理, 5=管理者, 6=協理, 7=維護者）
 * @param {React.ReactNode} children - 需要被保護的子元素
 * @param {React.ReactNode} fallback - 無權限時顯示的備選內容（可選）
 * 
 * 使用方式：
 * <RoleGuard requiredRole={5}>
 *   <button>只有維護者能看到</button>
 * </RoleGuard>
 * 
 * <RoleGuard requiredRole={2} fallback={<p>權限不足</p>}>
 *   <button>員工及以上才能看到</button>
 * </RoleGuard>
 */
export const RoleGuard = ({ requiredRole, children, fallback = null }) => {
  const hasRole = useHasRole(requiredRole);
  
  if (!hasRole) {
    return fallback;
  }
  
  return children;
};

/**
 * 條件渲染組件 - 只在滿足條件時顯示
 * @param {boolean} condition - 條件
 * @param {React.ReactNode} children - 條件為true時顯示
 * @param {React.ReactNode} fallback - 條件為false時顯示
 */
export const ConditionalRender = ({ condition, children, fallback = null }) => {
  return condition ? children : fallback;
};

export default RoleGuard;
